import React from 'react';

interface MoneyDisplayProps {
  value: number;
  currency?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'green' | 'red';
}

export default function MoneyDisplay({ value, currency = 'RON', className = '', size = 'md', color = 'default' }: MoneyDisplayProps) {
  const formatted = new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);

  const sizeClasses = { sm: 'text-sm', md: 'text-base', lg: 'text-lg font-semibold' };
  const colorClasses = { default: 'text-gray-900', green: 'text-green-600', red: 'text-red-600' };

  return (
    <span className={`${sizeClasses[size]} ${colorClasses[color]} ${className}`}>
      {formatted} {currency}
    </span>
  );
}
